<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast 1" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeModal">
      <!--кнопка закрытия модалки-->
      <button class="uk-close uk-close-large uk-modal-close-outside" type="button" data-uk-close @click="closeModal()"></button>
      <!--Название-->
      <div class="uk-modal-header">
        <!--ID функции-->
        <div class="uk-modal-title">
          <div class="uk-grid uk-flex-middle uk-grid-small" data-uk-grid>
            <div class="uk-text-bold">
              <h4 class="uk-text-bold">
                <button type="button"
                        @click="$emit('copyLink',function_name)"
                        style="padding: 0 5px;"
                        class="uk-icon uk-link-text" data-uk-tooltip="title: Копировать ссылку">
                  <md-icon>content_copy</md-icon>
                </button>
                {{ name }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-modal-body">
        <div v-html="prepareText(text)" class="uk-margin" v-if="text"></div>
        <!--кнопка на видео инструкцию -->
        <div class="uk-text-center uk-margin-top uk-grid uk-grid-small uk-flex-center tm-dialog-buttons">
          <template v-if="Array.isArray(video)">
            <div v-for="(current_video, key) in video" :key="key">
              <md-button
                  v-if="current_video" class="md-button md-succes uk-width-1-1"
                  target="_blank"
                  :href="current_video">
                {{ $parent.local_page_keys.button_instruction }}
                <span class="material-icons uk-margin-small-left">play_circle_outline</span>
              </md-button>
            </div>
          </template>
          <template v-else>
            <div>
              <md-button
                  v-if="video" class="md-button md-succes uk-width-1-1"
                  target="_blank"
                  :href="video">
                {{ $parent.local_page_keys.button_instruction }}
                <span class="material-icons uk-margin-small-left">play_circle_outline</span>
              </md-button>
            </div>
          </template>

        </div>
        <!--выводим фото "ДО" из галереи -->
        <div class="uk-grid uk-child-width-1-3 uk-flex-center tm-example-imgs uk-margin-medium-top" data-uk-grid>
          <div v-for="(item, i) in items" :key="i">
            <div v-if="item.src_before && item.src_after">
              <a class="uk-flex uk-flex-middle uk-flex-center uk-background-muted tm-example-imgs-box" href="#" @click="examples(i)">
                <div class="uk-inline-clip uk-transition-toggle">
                  <img :src="item.src_before" alt="">
                  <img class="uk-transition-fade uk-position-cover" :src="item.src_after" alt="">
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    name: String,
    text: String,
    show: Boolean,
    video: [Array, String, Object],
    function_name: String,
    items: {
      type: [Array, Object],
    }
  },
  methods: {
    examples(i) {
      this.$parent.$data.currentExampleCarouselIndex = i;
      this.$parent.showDialog6 = true;
      this.$parent.showDialog = false;
    },
    closeModal() {
        this.$emit('hide', true);
    },
    prepareText(text) {
      function replaceTextWithLink(text) {
        const linkRegex = /https:\/\/\S+/g;
        return text.replace(linkRegex, (match) => {
          return `<a href="${match}" target="_blank">${match}</a>`;
        });
      }

      return replaceTextWithLink(text);
    }
  },
}
</script>